import React from "react";

const DailyBeatPlanAdherence = ({ data }) => {
    if (!data) return null;

    return (
        <div className="spd-table-container">
            <h4 className="mb-3">Daily Beat Plan Adherence Report</h4>

            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>IC Name</th>
                            <th>Manager Name</th>
                            <th>Live</th>
                            <th>T-1</th>
                            <th>T-2</th>
                            <th>T-3</th>
                            <th>WTD</th>
                            <th>MTD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((row, idx) => (
                            <tr key={idx}>
                                <td><strong>{row.icName}</strong></td>
                                <td>{row.managerName}</td>
                                <td className="text-center">{row.live || '-'}</td>
                                <td className="text-center">{row.t1 || '-'}</td>
                                <td className="text-center">{row.t2 || '-'}</td>
                                <td className="text-center">{row.t3 || '-'}</td>
                                <td className="text-center">{row.wtd || '-'}</td>
                                <td className="text-center">{row.mtd || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DailyBeatPlanAdherence;
